import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './confirm-message-modal.component.html',
  styleUrls: ['./confirm-message-modal.component.scss']
})
export class ConfirmMessageModalComponent implements AfterViewInit{
  public confirmTitle: string;
  public confirmDescription: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  ngAfterViewInit(): void {
    this.confirmTitle = this.data.confirmTitle;
    this.confirmDescription = this.data.confirmDescription;
  }



}
